/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {SimTabContentHostDirective as ɵb} from './tab-content-host.directive';
export {SimTabHeaderComponent as ɵc} from './tab-header.component';
export {TabInkBarComponent as ɵa} from './tab-ink-bar.component';
export {SimTabLabelWrapperDirective as ɵd} from './tab-label-wrapper.directive';